import { LOGIN_SUCCESS, LOGIN_FAILURE, LOGOUT_SUCCESS } from '../actions/firebaseActions';

const initialState = {
  isLoggedIn: false,
  error: null,
  user: null,
};

const firebaseReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_SUCCESS:
      return {
        ...state,
        isLoggedIn: true,
        error: null,
        user: action.payload
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        isLoggedIn: false,
        error: action.payload
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        isLoggedIn: false,
        error: null
      };
    default:
      return state;
  }
};

export default firebaseReducer;